import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";

const AssessmentForm = ({modal, assestmentID, assessmentName,weight,rca, active, isLoading, onSubmit, onHide}) => {
    const validation = Yup.object({
        assestmentName: Yup.string().required(),
        weight: Yup.number().required(),
        rca: Yup.number().required()
        //test: Yup.string().required()
    })
    return (<>
        <BootstrapModal headerText="Add Assessment" size={30} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{assestmentID: assestmentID, assestmentName: assessmentName,weight:weight, active: active}}
                onSubmit={onSubmit}>
                {formik =>
                    (<>
                        <Form>
                            <Field type="hidden" name="assestmentID"/>
                            <TextField label={'assessment Name'} type="text" name="assestmentName"/>
                            <TextField label={'Weight'} type="text" name="weight"/>
                            <TextField label={'RCA'} type="text" name="rca"/>
                            {/*<FormSelect id="test" name="test" options={[
                                {value: '', label: 'Please Select assessment'},
                                {value: '1', label: 'test 1'},
                                {value: '2', label: 'test 1'}]}/>*/}

                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" disabled={isLoading} className="btn btn-primary">{assestmentID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    </>)}

            </Formik>

        </BootstrapModal>

    </>)
}

export default AssessmentForm